import validate from "/usr/src/app/node_modules/.pnpm/nuxt@3.17.7_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.1.0_@vue+compiler_8d6b4e89a398bdcfca57eb2b25d191b6/node_modules/nuxt/dist/pages/runtime/validate.js";
import clear_45language_45switcher_45links_45global from "/usr/src/app/src/middleware/clearLanguageSwitcherLinks.global.ts";
import manifest_45route_45rule from "/usr/src/app/node_modules/.pnpm/nuxt@3.17.7_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.1.0_@vue+compiler_8d6b4e89a398bdcfca57eb2b25d191b6/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  clear_45language_45switcher_45links_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "get-layout": () => import("/usr/src/app/src/middleware/getLayout.ts"),
  "logged-in-redirect": () => import("/usr/src/app/src/middleware/loggedInRedirect.ts")
}